import { _ } from "core-js"

const state = {
    documents: [],
    bundles: [],
    fileTypes: [],
    listener: null,
    pendingApplicantDocuments: [],
    pendingDealerDocuments: [],
    pendingSellerDocuments: [],
    pendingRefinanceDocuments: [],
    pendingPersonalDocuments: [],
    completeDocumentsList: [],
    applicantDocumentsList: [],
    dealerDocumentsList: [],
    sellerDocumentsList: [],
    refinanceDocumentsList: [],
    personalDocumentsList: [],
    conditioningSignatures: [],
}

const getters = {
    all: state => state.documents,
    fileTypes: state => state.fileTypes,
    pendingApplicantDocuments: state => state.pendingApplicantDocuments,
    pendingDealerDocuments: state => state.pendingDealerDocuments,
    pendingSellerDocuments: state => state.pendingSellerDocuments,
    pendingRefinanceDocuments: state => state.pendingRefinanceDocuments,
    pendingPersonalDocuments: state => state.pendingPersonalDocuments,
    completeDocumentsList: state => state.completeDocumentsList,
    applicantDocumentsList: state => state.applicantDocumentsList,
    dealerDocumentsList: state => state.dealerDocumentsList,
    sellerDocumentsList: state => state.sellerDocumentsList,
    refinanceDocumentsList: state => state.refinanceDocumentsList,
    personalDocumentsList: state => state.personalDocumentsList,
    conditioningSignatures: state => state.conditioningSignatures,
}

const mutations = {
    setDocuments(state, documents) {
        state.documents = Array.isArray(documents) ? documents : []
    },

    setPendingApplicantDocuments(state, pendingApplicantDocuments) {
        state.pendingApplicantDocuments = Array.isArray(pendingApplicantDocuments) ? pendingApplicantDocuments : []
    },

    setPendingDealerDocuments(state, pendingDealerDocuments) {
        state.pendingDealerDocuments = Array.isArray(pendingDealerDocuments) ? pendingDealerDocuments : []
    },

    setPendingSellerDocuments(state, pendingSellerDocuments) {
        state.pendingSellerDocuments = Array.isArray(pendingSellerDocuments) ? pendingSellerDocuments : []
    },

    setPendingRefinanceDocuments(state, pendingRefinanceDocuments) {
        state.pendingRefinanceDocuments = Array.isArray(pendingRefinanceDocuments) ? pendingRefinanceDocuments : []
    },

    setPendingPersonalDocuments(state, pendingPersonalDocuments) {
        state.pendingPersonalDocuments = Array.isArray(pendingPersonalDocuments) ? pendingPersonalDocuments : []
    },

    setFileTypes(state, types) {
        state.fileTypes = types
    },

    setCompleteDocumentsList(state, completeDocumentsList) {
        state.completeDocumentsList = completeDocumentsList
    },

    setApplicantDocumentsList(state, applicantDocumentsList) {
        state.applicantDocumentsList = applicantDocumentsList
    },

    setDealerDocumentsList(state, dealerDocumentsList) {
        state.dealerDocumentsList = dealerDocumentsList
    },

    setSellerDocumentsList(state, sellerDocumentsList) {
        state.sellerDocumentsList = sellerDocumentsList
    },

    setRefinanceDocumentsList(state, refinanceDocumentsList) {
        state.refinanceDocumentsList = refinanceDocumentsList
    },

    setPersonalDocumentsList(state, personalDocumentsList) {
        state.personalDocumentsList = personalDocumentsList
    },

    setListener(state, listener) {
        state.listener = listener
    },

    updateDocuments(state, documents) {
        console.log("documents/updateDocument")
        state.documents = _.chain(documents)
            .concat(state.documents)
            .unionBy("id") // result values are chosen from the first array in which the value occurs (i.e. documents)
            .value()
    },

    deleteDocuments(state, documents) {
        console.log("documents/deleteDocument")
        state.documents = _.chain(state.documents)
            .differenceBy(documents, "id") // order and references of result values are determined by the first array
            .value()
    },

    setConditioningSignatures(state) {

        let application = $store.getters.initAppData
        let applicants = _.get(application, 'applicants', [])

        let conditionSignatures = [];
        if (!_.isEmpty(applicants)) {
            applicants.forEach(applicant => {

                let privacyConsentForm = state.documents.filter(document => !_.isEmpty(document.document_type) && document.document_type.name == "Privacy Consent Form").find(conditionSignature => conditionSignature.uploader_id == applicant.id)
                let vwPrivacyConsentForm = state.documents.filter(document => !_.isEmpty(document.document_type) && document.document_type.name == "VW Privacy Consent Form").find(conditionSignature => conditionSignature.uploader_id == applicant.id)
                let macPrivacyConsentForm = state.documents.filter(document => !_.isEmpty(document.document_type) && document.document_type.name == "MAC Privacy Consent Form").find(conditionSignature => conditionSignature.uploader_id == applicant.id)
                let creditGuideQuote = state.documents.filter(document => !_.isEmpty(document.document_type) && document.document_type.name == "Credit Guide Quote").find(conditionSignature => conditionSignature.uploader_id == applicant.id)

                conditionSignatures.push({
                    privacyConsentForm: privacyConsentForm ? privacyConsentForm : false,
                    vwPrivacyConsentForm: vwPrivacyConsentForm ? vwPrivacyConsentForm : false,
                    macPrivacyConsentForm: macPrivacyConsentForm ? macPrivacyConsentForm : false,
                    creditGuideQuote: creditGuideQuote ? creditGuideQuote : false,
                    applicant: applicant,
                    signature: _.orderBy(application.condition_signature, 'created_at').find(signature => signature.applicant_id == applicant.id && !signature.deleted_at),
                    previousSignature: _.orderBy(application.condition_signature, 'created_at').find(signature => signature.applicant_id == applicant.id && signature.deleted_at),
                })
            })
        }
        state.conditioningSignatures = conditionSignatures
    }
}

const actions = {

    clearDocuments(context, payload) {
        context.commit("setDocuments", [])
    },

    setPendingApplicantDocuments({ dispatch, commit, state }, data) {
        // pending applicant documents
        let applicantTempDocs = {};
        state.documents.forEach(doc => {
            if (!doc.backend_uploaded && doc.status !== "Approved" && doc.doc_category == 'customer') {
                if (applicantTempDocs[doc.uploader_id]) {
                    applicantTempDocs[doc.uploader_id].push(doc.document_type_id);
                } else {
                    applicantTempDocs[doc.uploader_id] = [doc.document_type_id];
                }
            }
        });
        let pendingApplicantDocuments = [];
        Object.keys(applicantTempDocs).forEach(t => {
            pendingApplicantDocuments.push({
                applicant_id: t,
                documents: applicantTempDocs[t]
            })
        })
        commit("setPendingApplicantDocuments", pendingApplicantDocuments)
    },

    setPendingDealerDocuments({ dispatch, commit, state }, data) {
        // pending dealer documents
        let pendingDealerDocumentsObject = state.documents.filter(doc => {
            if (doc.status !== "Approved" && !doc.deleted_at && _.get(doc, 'document_type.section', false)) {
                return doc.document_type.sections.find(section => section.name == 'Dealer Documents')
            }
        })
        let pendingDealerDocuments = pendingDealerDocumentsObject.map(documentObject => documentObject.document_type_id)
        commit("setPendingDealerDocuments", pendingDealerDocuments)
    },

    setPendingSellerDocuments({ dispatch, commit, state }, data) {
        // pending seller documents
        let pendingSellerDocumentsObject = state.documents.filter(doc => {
            if (doc.status !== "Approved" && !doc.deleted_at && _.get(doc, 'document_type.section', false)) {
                return doc.document_type.sections.find(section => section.name == 'Private Sale Documents')
            }
        })
        let pendingSellerDocuments = pendingSellerDocumentsObject.map(documentObject => documentObject.document_type_id)
        commit("setPendingSellerDocuments", pendingSellerDocuments)
    },

    setPendingRefinanceDocuments({ dispatch, commit, state }, data) {
        // pending refinance documents
        let pendingRefinanceDocumentsObject = state.documents.filter(doc => {
            if (doc.status !== "Approved" && !doc.deleted_at && _.get(doc, 'document_type.section', false)) {
                return doc.document_type.sections.find(section => section.name == 'Refinance Documents')
            }
        })
        let refinanceTempDocs = {}
        if (pendingRefinanceDocumentsObject) {
            pendingRefinanceDocumentsObject.forEach(doc => {
                if (refinanceTempDocs[doc.uploader_id]) {
                    refinanceTempDocs[doc.uploader_id].push(doc.document_type_id);
                } else {
                    refinanceTempDocs[doc.uploader_id] = [doc.document_type_id];
                }
            })
        }
        let pendingRefinanceDocuments = [];
        Object.keys(refinanceTempDocs).forEach(t => {
            pendingRefinanceDocuments.push({
                applicant_id: t,
                documents: refinanceTempDocs[t]
            })
        })
        commit("setPendingRefinanceDocuments", pendingRefinanceDocuments)
    },

    setPendingPersonalDocuments({ dispatch, commit, state }, data) {
        // pending refinance documents
        let pendingPersonalDocumentsObject = state.documents.filter(doc => {
            if (doc.status !== "Approved" && !doc.deleted_at && _.get(doc, 'document_type.section', false)) {
                return doc.document_type.sections.find(section => section.name == 'Personal Loan Documents')
            }
        })
        let refinanceTempDocs = {}
        if (pendingPersonalDocumentsObject) {
            pendingPersonalDocumentsObject.forEach(doc => {
                if (refinanceTempDocs[doc.uploader_id]) {
                    refinanceTempDocs[doc.uploader_id].push(doc.document_type_id);
                } else {
                    refinanceTempDocs[doc.uploader_id] = [doc.document_type_id];
                }
            })
        }
        let pendingPersonalDocuments = [];
        Object.keys(refinanceTempDocs).forEach(t => {
            pendingPersonalDocuments.push({
                applicant_id: t,
                documents: refinanceTempDocs[t]
            })
        })
        commit("setPendingPersonalDocuments", pendingPersonalDocuments)
    },

    fetchDocuments(context, { allowSuccessiveFetch = false } = {}) {
        if (!allowSuccessiveFetch && context.state.documents.length > 0) {
            return console.warn(
                "fetchDocuments(): successive fetch has been disabled, sockets will handle further updates to store [allowSuccessiveFetch = false]"
            )
        }
        Ambition.Request.call({
            url: "/api/application/{application}/finalise/documents",
            params: { excludes: "pdf_versions" }
        }).then(e => {

            const { documents, bundles } = e.data
            context.commit("setDocuments", documents)

            context.dispatch("setPendingApplicantDocuments")
            context.dispatch("setPendingDealerDocuments")
            context.dispatch("setPendingSellerDocuments")
            context.dispatch("setPendingRefinanceDocuments")
            context.dispatch("setPendingPersonalDocuments")

            if (!context.state.listener) {
                // context.dispatch("startPollListener")
                context.dispatch("startSocketListener")
            }
            if (context.state.fileTypes.length === 0) {
                // context.dispatch("fetchDocumentTypes")
            }
        })
    },

    fetchFileTypes(context) {
        console.log("documents/fetchFileTypes")
        Ambition.Request.call({
            admin: true,
            method: "GET",
            url: `{admin_url}/api/documents`
        }).then(e => {
            let fileTypes = e.data
            context.commit("setFileTypes", fileTypes)

            // create the complete document list
            let completeDocumentsList = []
            let completeBlacklist = []
            fileTypes.forEach(fileType => {
                if (!completeBlacklist.includes(fileType.name)) {
                    completeDocumentsList.push({
                        displayName: fileType.name,
                        id: fileType.id,
                        name: _.camelCase(fileType.name),
                        glaDefaultName: fileType.gla_document_name
                    });
                }
            });
            // set the complete document list
            context.commit("setCompleteDocumentsList", completeDocumentsList)

            // create the applicant document list
            let applicantDocumentsList = []
            let applicantBlacklist = ['Credit Proposal', 'Brokers Invoice', 'Preliminary Assessment']
            fileTypes.forEach(fileType => {
                if (!applicantBlacklist.includes(fileType.name) && fileType.document_type == "customer") {
                    applicantDocumentsList.push({
                        displayName: fileType.name,
                        id: fileType.id,
                        name: _.camelCase(fileType.name),
                        glaDefaultName: fileType.gla_document_name
                    });
                }
            });

            context.commit("setApplicantDocumentsList", applicantDocumentsList)

            // set the dealer document list
            let dealerDocumentsList = []
            let dealerFileTypes = fileTypes.filter(fileType => fileType.sections.find(section => section.name == 'Dealer Documents'))
            dealerFileTypes.forEach(fileType => {
                dealerDocumentsList.push({
                    displayName: fileType.name,
                    id: fileType.id,
                    name: _.camelCase(fileType.name),
                    glaDefaultName: fileType.gla_document_name
                });
            });
            context.commit("setDealerDocumentsList", dealerDocumentsList)

            // create the seller document list
            let sellerDocumentsList = []
            let sellerBlacklist = []
            fileTypes.forEach(fileType => {
                if (!sellerBlacklist.includes(fileType.name) && fileType.document_type == "seller") {
                    sellerDocumentsList.push({
                        displayName: fileType.name,
                        id: fileType.id,
                        name: _.camelCase(fileType.name),
                        glaDefaultName: fileType.gla_document_name
                    });
                }
            });
            context.commit("setSellerDocumentsList", sellerDocumentsList)

            // set the refinance document list
            let refinanceDocumentsList = []
            let refinanceFileTypes = fileTypes.filter(fileType => fileType.sections.find(section => section.name == 'Refinance Documents'))
            refinanceFileTypes.forEach(fileType => {
                refinanceDocumentsList.push({
                    displayName: fileType.name,
                    id: fileType.id,
                    name: _.camelCase(fileType.name),
                    glaDefaultName: fileType.gla_document_name
                });
            });
            context.commit("setRefinanceDocumentsList", refinanceDocumentsList)

            // set the personal document list
            let personalDocumentsList = []
            let personalFileTypes = fileTypes.filter(fileType => fileType.sections.find(section => section.name == 'Personal Loan Documents'))
            personalFileTypes.forEach(fileType => {
                personalDocumentsList.push({
                    displayName: fileType.name,
                    id: fileType.id,
                    name: _.camelCase(fileType.name),
                    glaDefaultName: fileType.gla_document_name
                });
            });
            context.commit("setPersonalDocumentsList", personalDocumentsList)

        })

    },
    setConditioningSignatures(context, payload) {
        context.commit('setConditioningSignatures')
    },
    startSocketListener(context, payload) {
        console.log("documents/startSocketListener")
        const applicationId = Ambition.getGlobal("tenant.applicationId")
        context.dispatch("setConditioningSignatures")

        const eventHandler = response => {
            console.log("documents/startSocketListener::event", response)
            const { documents, bundles, eventType } = response

            if (!Array.isArray(documents) || typeof eventType !== "string") {
                console.log(response)
                return console.error("documents/startSocketListener", "document or eventType property is invalid")
            }

            const eventMethods = {
                created: "updateDocuments",
                updated: "updateDocuments",
                deleted: "deleteDocuments"
            }

            context.commit(eventMethods[eventType], documents)
            context.commit("setListener", true)

            context.dispatch("setPendingApplicantDocuments")
            context.dispatch("setPendingDealerDocuments")
            context.dispatch("setPendingSellerDocuments")
            context.dispatch("setPendingRefinanceDocuments")
            context.dispatch("setPendingPersonalDocuments")

            context.dispatch("setConditioningSignatures")
        }

        Echo.private(`documents.${window.Tenant}.${applicationId}`)
            .listen("DocumentEvent", eventHandler)
            .listen("AppDocumentEvent", eventHandler)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
